export default function getTenantFromPath(): string {
  if (!window.location) {
    return ""
  }
  const subdomain = window.location.hostname.split(".")[0]
  if (exceptions.indexOf(subdomain) > -1) {
    return ""
  }
  return subdomain
}

export const exceptions: string[] = ["perkbox", "www", "localhost", "app"]
